// extracted by mini-css-extract-plugin
export default {"incidentInfo":"styles_incidentInfo__5ExW-","title":"styles_title__Uh9Eb","info":"styles_info__yYuxp"};